<template>
  <div>
    <!-- Header Section -->
    <section id="kb-category-search">
      <b-card
        no-body
        class="apps-market-bg text-center"
        :style="{backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`}"
      >
        <b-card-body class="card-body">
          <h2 class="text-primary">
            {{ $t('modules.apps._messages.installed_apps') }}
          </h2>
          <b-card-text class="mb-2">
            <span>{{ $t('modules.apps._messages.installed_apps_description') }}</span>
          </b-card-text>
        </b-card-body>
      </b-card>
    </section>

    <!-- Installed Apps Content -->
    <div id="installed-apps-list">
      <!-- Loading State -->
      <div
        v-if="isLoading"
        class="text-center"
      >
        <b-spinner
          variant="primary"
          label="Loading..."
        />
      </div>

      <!-- Apps Grid -->
      <b-row
        v-else
        class="match-height"
      >
        <b-col
          v-for="app in installedApps"
          :key="app.id"
          md="6"
          lg="4"
          sm="12"
        >
          <installed-app-card
            :app="app"
            @renew-subscription="code => buyNow(code)"
          />
        </b-col>

        <!-- No Apps Found -->
        <b-col
          v-show="!installedApps.length && !isLoading"
          cols="12"
          class="text-center"
        >
          <h4 class="mt-4">
            {{ $t('modules.apps._messages.no_installed_apps') }}
          </h4>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BCardText, BSpinner,
} from 'bootstrap-vue'
import InstalledAppCard from '@/views/models/apps/InstalledAppCard.vue'
import { ref, onMounted } from 'vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { catchException, toast } from '@core/utils/utils'
import axios from '@axios'
import { usePurchaseCart } from '@/views/models/purchases/usePurchaseCart'

export default {
  components: {
    InstalledAppCard,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BSpinner,
  },
  setup() {
    const installedApps = ref([])
    const isLoading = ref(false)
    const { t } = useI18nUtils()

    const fetchInstalledApps = () => {
      isLoading.value = true
      axios
        .get('/dashboard/v1/apps/')
        .then(response => {
          if (response && response.status === 200) {
            installedApps.value = response.data.data || []
          }
        })
        .catch(e => {
          catchException(e)
          toast(
            'danger',
            t('message.error_fetching_list'),
            null,
            'AlertTriangleIcon',
          )
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    onMounted(() => {
      fetchInstalledApps()
    })

    const { buyNow } = usePurchaseCart()

    return {
      installedApps,
      isLoading,
      buyNow,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';

#installed-apps-list {
  margin-top: 2rem;
}
</style>
